(function () {
  'use strict';

  if (window.__klaviyoFooterTriggerReady) return;
  window.__klaviyoFooterTriggerReady = true;

  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var klaviyoSelector = '[data-testid*="klaviyo" i], [class*="kl-private-reset-css"], [class*="klaviyo-form"]';
  var activeFormId;
  var activeDialog;
  var returnFocus;
  var observer;

  function isVisible(element) {
    for (var current = element; current; current = current.parentElement) {
      var style = window.getComputedStyle(current);
      if (current.hidden
        || current.getAttribute('aria-hidden') === 'true'
        || style.display === 'none'
        || style.visibility === 'hidden') return false;
    }

    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getDialog() {
    if (activeDialog && activeDialog.isConnected && isVisible(activeDialog)) return activeDialog;

    var dialogs = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');

    for (var index = dialogs.length - 1; index >= 0; index -= 1) {
      if (!isVisible(dialogs[index])) continue;
      if (dialogs[index].matches(klaviyoSelector) || dialogs[index].querySelector(klaviyoSelector)) {
        activeDialog = dialogs[index];
        return activeDialog;
      }
    }

    return null;
  }

  function getFocusable(dialog) {
    return Array.prototype.filter.call(dialog.querySelectorAll(focusableSelector), isVisible);
  }

  function getCloseButton(dialog) {
    var selector = [
      'button[aria-label*="close" i]',
      '[role="button"][aria-label*="close" i]',
      'button[title*="close" i]',
      'button[data-testid*="close" i]'
    ].join(',');
    return Array.prototype.filter.call(dialog.querySelectorAll(selector), isVisible)[0];
  }

  function focusDialog(preferClose) {
    var dialog = getDialog();
    if (!dialog || (dialog.contains(document.activeElement) && isVisible(document.activeElement))) return;

    var focusable = getFocusable(dialog);
    var target = preferClose && getCloseButton(dialog) || focusable[0] || dialog;
    if (target === dialog && !dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  function watchDialog() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        focusDialog(true);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.requestAnimationFrame(function () {
      focusDialog(false);
    });
  }

  function stopWatchingDialog() {
    if (observer) observer.disconnect();
    observer = undefined;
    activeFormId = undefined;
    activeDialog = undefined;

    var target = returnFocus;
    returnFocus = undefined;
    window.requestAnimationFrame(function () {
      if (target && target.isConnected) target.focus({ preventScroll: true });
    });
  }

  function openKlaviyoForm(formId, trigger) {
    activeFormId = String(formId);
    returnFocus = trigger;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaviyo-popup-trigger]');
    if (!trigger) return;

    event.preventDefault();
    openKlaviyoForm(trigger.getAttribute('data-klaviyo-popup-trigger'), trigger);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-klaviyo-popup-trigger]');
    if (!form) return;

    event.preventDefault();
    var trigger = form.contains(document.activeElement) ? document.activeElement : form;
    openKlaviyoForm(form.getAttribute('data-klaviyo-popup-trigger'), trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (!observer) return;

    var dialog = getDialog();
    if (!dialog) return;

    if (event.key === 'Escape') {
      var closeButton = getCloseButton(dialog);
      if (!closeButton) return;
      event.preventDefault();
      event.stopPropagation();
      closeButton.click();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(dialog);
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (!first) {
      event.preventDefault();
      focusDialog(false);
    } else if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (!activeFormId || String(detail.formId) !== activeFormId) return;

    if (detail.type === 'open') watchDialog();
    if (detail.type === 'submit' || detail.type === 'stepSubmit') focusDialog(true);
    if (detail.type === 'close' || detail.type === 'redirectedToUrl') stopWatchingDialog();
  });
})();
